import * as S from './styles';
//context
import { useCart } from 'context/CartContex';
//components
import CardPromotions from '../CardPromotions';
//Utils
import { CalcAmountAndValue } from "utils/FunctionOrder";
//icons
import {
    CreditCard,
    Eyeglasses,
    Trash,
    Plus,
    Minus,
    CircleHalfTilt,
    Gift,
    Screwdriver
} from '@phosphor-icons/react';

interface ICard {
    selectedProducts: any[];
    onDeleteProduct: (index: number) => void;
    onEditProduct: (item: any) => void;
}

export default function CardOrder({
    selectedProducts,
    onDeleteProduct,
    onEditProduct
}: ICard) {

    const { updateQuantity } = useCart();

    // Função para mapear tipo ao nome e ícone
    const getProductTypeInfo = (type: string) => {
        switch (type) {
            case 'frame':
                return { label: 'Armação', icon: <Eyeglasses size={20} /> };
            case 'lens':
                return { label: 'Lente', icon: <CircleHalfTilt size={20} /> };
            case 'accessory':
            case 'accessories':
                return { label: 'Acessório', icon: <Gift size={20} /> };
            case 'service':
                return { label: 'Serviço', icon: <Screwdriver size={20} /> };
            default:
                return { label: '', icon: <></> }; // vazio para tipo desconhecido
        }
    };

    // Função que retorna o nome correto para exibir no título
    const getProductDisplayName = (val: any): string => {
        switch (val.type) {
            case 'lens':
                return val.name_lens || val.code || '-';
            case 'frame':
                return `${val.code || ''} ${val.brands?.brand || ''}`.trim() || '-';
            case 'service':
                return `${val.code || ''}`;
            default:
                return val.name || val.code || '-';
        }
    };

    return (
        <S.Container>
            {
                selectedProducts.map((val: any) => {
                    const originalPrice = CalcAmountAndValue(val.price || 0, val.quantity, 0);
                    const discount = val.promotions ?
                        val.promotions?.personalized_discount || 0 :
                        0;
                    const discountedPrice = CalcAmountAndValue(
                        Number(val.price),
                        val.quantity,
                        Number(discount)
                    );
                    const activePromo = val.payments && val.payments.length > 0;
                    return (
                        <S.Content>
                            <S.Header>
                                <S.HeaderLeft>
                                    {(() => {
                                        const { icon, label } = getProductTypeInfo(val.type);
                                        return (
                                            <>
                                                {icon}
                                                <span>{label}</span>
                                            </>
                                        );
                                    })()}
                                </S.HeaderLeft>

                                <S.Button
                                    type='button'
                                    onClick={() => onDeleteProduct(val)}
                                >
                                    <Trash size={24} />
                                </S.Button>
                            </S.Header>

                            <S.Body>
                                <S.ContentColumn>
                                    <S.Title>
                                        {getProductDisplayName(val)}
                                    </S.Title>

                                    {
                                        val.details &&
                                        <S.Text className='subtitle'>
                                            {val.details || ''}
                                        </S.Text>
                                    }
                                    <S.ButtonPromotion
                                        isActive={activePromo}
                                        type='button'
                                        className='promotion'
                                        onClick={() => onEditProduct(
                                            val
                                        )}
                                    >
                                        <CreditCard size={12} />
                                        Processar Pagamento
                                    </S.ButtonPromotion>

                                    <S.ContentQuantity>
                                        <S.Button
                                            type='button'
                                            className='button-quantity'
                                            onClick={() => {
                                                if (val.quantity > 1) {
                                                    updateQuantity(val.id, val.quantity - 1);
                                                }
                                            }}
                                        >
                                            <Minus size={14} />
                                        </S.Button>
                                        <S.Input
                                            type="number"
                                            min={1}
                                            value={val.quantity || 1}
                                            onChange={(e) => {
                                                const newQuantity = Number(e.target.value);
                                                if (newQuantity >= 1) {
                                                    updateQuantity(val.id, newQuantity);
                                                }
                                            }}
                                        />
                                        <S.Button
                                            type='button'
                                            className='button-quantity'
                                            onClick={() => updateQuantity(val.id, val.quantity + 1)}
                                        >
                                            <Plus size={14} />
                                        </S.Button>
                                    </S.ContentQuantity>
                                </S.ContentColumn>

                                <S.ContentColumn>
                                    {
                                        originalPrice !== discountedPrice &&
                                        <S.Text className='underline'>
                                            {originalPrice}
                                        </S.Text>
                                    }
                                    <S.Text className='title'>
                                        {discountedPrice}
                                    </S.Text>
                                </S.ContentColumn>

                            </S.Body>
                            {
                                activePromo &&
                                <CardPromotions
                                    title={val.promotions?.title || '-'}
                                    discount={val.promotions?.personalized_discount || 0}
                                    method_payments={val.payments || []}
                                    idProduct={val.id}
                                />
                            }
                        </S.Content>
                    )
                })
            }
        </S.Container>
    )
}